module.exports = __webpack_public_path__ + "static/media/image-6.9517375f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Trip/image-6.jpg
// module id = 283
// module chunks = 0